var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.6309,
    y: 0.824219,
    width: 17.1146,
    height: 26.1222,
    rx: 1.80153,
    fill: "#DCE949"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0195312,
    y: 3.52734,
    width: 17.1146,
    height: 26.1222,
    rx: 1.80153,
    fill: "#F1FF51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleYellow);
export default __webpack_public_path__ + "static/media/double_yellow.c3c48c1ac388b99140979d45931d7491.svg";
export { ForwardRef as ReactComponent };